<!--
 * @Description: 日程列表页
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-07-02 14:18:00
 * @LastEditors: 山淑兰
 -->
<template>
	<div class="list">
		<div class="loading" v-if="loading">
			<van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="16px">加载中...</van-loading>
		</div>
		<div class="list-con" v-if="!loading">
			<div class="details-return" @click="goBack()">
				<img src="../../../assets/back.png">
			</div>
			<template v-if="$i18n.locale === 'zh-CN'">
				<ul class="meetinglist" v-if="datas&&!showPopuop" :key="datas.roomid">
					<li>
						<div class="meeting-top">
							<div class="meeting-info">
								<div class="meeting-add">
									<van-cell :title="datas.roomname" class="meetingTitle" />
								</div>
								<div class="meeting-time">
									<van-cell :value="datas.prodate + ' ' +datas.starttime + '-' + datas.endtime"
										class="forumDate-time" />
								</div>
								<div class="meeting-title">
									{{ datas.roomtitle }}
								</div>
							</div>
							<div class="meeting-icon" v-if="datas.roomurl!=null">
								<a :href="datas.roomurl" target="_top">
									<p><img src="../../../assets/creame3.png">
										观看直播</p>
								</a>
							</div>
						</div>
					</li>
					<ul class="meetinglists">
						<li v-for="(items, indexs) in dataList" :key="indexs">
							<div class="meeting-infos meeting-infos-zhu" :id="`top${items.proid}`">
								<div class="meeting-times">
									{{ items.startime }}~{{ items.endtime }}
								</div>
								<div class="meeting-nextDatas">
									<ul v-if="items.exData.length>0">
										<div class="talker-topic" v-html="nToBr(items.topic)"></div>
										<li v-for="(i, j) in items.exData" :key="j">
											<!-- <div class="talker">
                        <span>{{ i.rolename }}</span>
                      </div> -->
											<div class="talker-name">
												<p>
													{{ i.rolename }}
													<!-- <span v-if="i.exname.length>3" v-for="(s, k) in i.exname" :key="k" @click="todetails(i.exid[k])">
                                  {{s}}
                              </span> -->
												<div class="talker-name-p" v-for="(s, k) in i.exname" :key="k"
													@click="todetails(i.exid[k])">
													<p v-html="nToBr(s)"></p>
													<p v-if="i.excompany[k]!=null&&i.excompany[k]!=''"  v-html="nToBr(i.excompany[k])"></p>
												</div>
												</p>
											</div>
										</li>
									</ul>
									<ul v-else>
										<li>
											<div class="talker-name">
												<span v-html="nToBr(items.topic)"></span>
											</div>
										</li>
									</ul>
								</div>
							</div>
							<ul class="meetinglists" v-if="items.children.length>0">
								<li v-for="(itemss, indexss) in items.children" :key="indexss"  :id="`top${itemss.proid}`">
									<div class="meeting-infos">
										<div class="meeting-times">
											{{ itemss.startime }}~{{ itemss.endtime }}
										</div>
										<div class="meeting-nextDatas">
											<ul v-if="itemss.exData.length>0">
												<div class="talker-topic" v-html="nToBr(itemss.topic)"></div>
												<li v-for="(i, j) in itemss.exData" :key="j">
													<!-- <div class="talker">
                            <span>{{ i.rolename }}</span>
                          </div> -->
													<div class="talker-name">
														<p>
															{{ i.rolename }}
															<!-- <span v-if="i.exname.length>3" v-for="(s, k) in i.exname" :key="k" @click="todetails(i.exid[k])">
                                      {{s}}
                                  </span> -->
														<div class="talker-name-p" v-for="(s, k) in i.exname" :key="k"
															@click="todetails(i.exid[k])">
															<p v-html="nToBr(s)"></p>
															<p v-if="i.excompany[k]!=null&&i.excompany[k]!=''" v-html="nToBr(i.excompany[k])"></p>
														</div>
														</p>
													</div>
												</li>
											</ul>
											<ul v-else>
												<li>
													<div class="talker-name">
														<span v-html="nToBr(itemss.topic)"></span>
													</div>
												</li>
											</ul>
										</div>
									</div>
								</li>
							</ul>
						</li>
					</ul>
				</ul>
			</template>
			<template v-else>
		 	<ul class="meetinglist" v-if="datas&&!showPopuop" :key="datas.roomid">
					<li>
						<div class="meeting-top">
							<div class="meeting-info">
								<div class="meeting-add">
									<van-cell
										:title="datas.roomenname!=null&&datas.roomenname!=''?datas.roomenname:datas.roomname"
										class="meetingTitle" />
								</div>
								<div class="meeting-time">
									<van-cell :value="datas.prodate + ' ' +datas.starttime + '-' + datas.endtime"
										class="forumDate-time" />
								</div>
								<div class="meeting-title">
									{{ datas.roomentitle!=null && datas.roomentitle!=''?datas.roomentitle:datas.roomtitle }}
								</div>
							</div>
							<div class="meeting-icon" v-if="datas.roomurl!=null">
								<a :href="datas.roomurl" target="_top">
									<p><img src="../../../assets/creame3.png">
										观看直播</p>
								</a>
							</div>
						</div>
					</li>
					<ul class="meetinglists">
						<li v-for="(items, indexs) in dataList" :key="indexs">
							<div class="meeting-infos meeting-infos-zhu" :id="`top${items.proid}`">
								<div class="meeting-times">
									{{ items.startime }}~{{ items.endtime }}
								</div>
								<div class="meeting-nextDatas">
									<ul v-if="items.exData.length>0">
		 							<div class="talker-topic" v-html="items.entopic!=null&&items.entopic!=''?nToBr(items.entopic):nToBr(items.topic)">
										</div>
										<li v-for="(i, j) in items.exData" :key="j">
											<!-- <div class="talker">
		                 <span>{{ i.rolename }}</span>
		               </div> -->
											<div class="talker-name">
												<p>
													{{ i.rolename }}
													<!--  <span v-if="i.exname.length>3" v-for="(s, k) in i.exname" :key="k" @click="todetails(i.exid[k])">
		                           {{i.exenname[k]!=''&&i.exenname[k]!=null?i.exenname[k]:s}}
		                       </span> -->
												<div class="talker-name-p" v-for="(s, k) in i.exname" :key="k"
													@click="todetails(i.exid[k])">
													<p v-html="i.exenname[k]!=''&&i.exenname[k]!=null?nToBr(i.exenname[k]):nToBr(s)"></p>
													<p v-if="i.excompany[k]!=null&&i.excompany[k]!=''"
														v-html="i.exencompany[k]!=''&&i.exencompany[k]!=null?nToBr(i.exencompany[k]):nToBr(i.excompany[k])">
													</p>
												</div>
												</p>
											</div>
										</li>
									</ul>
									<ul v-else>
										<li>
											<div class="talker-name">
												<span v-html="items.entopic!=null&&items.entopic!=''?nToBr(items.entopic):nToBr(items.topic)"></span>
											</div>
		 							</li>
									</ul>
								</div>
							</div>
							<ul class="meetinglists" v-if="items.children.length>0">
								<li v-for="(itemss, indexss) in items.children" :key="indexss" :id="`top${itemss.proid}`">
									<div class="meeting-infos">
										<div class="meeting-times">
											{{ itemss.startime }}~{{ itemss.endtime }}
										</div>
										<div class="meeting-nextDatas">
											<ul v-if="itemss.exData.length>0">
												<div class="talker-topic">
													{{itemss.entopic!=null&&itemss.entopic!=''?itemss.entopic:itemss.topic }}
												</div>
												<li v-for="(i, j) in itemss.exData" :key="j">
													<!-- <div class="talker">
		                     <span>{{ i.rolename }}</span>
		                   </div> -->
													<div class="talker-name">
														<p>
															{{ i.rolename }}
															<!-- <span v-if="i.exname.length>3" v-for="(s, k) in i.exname" :key="k" @click="todetails(i.exid[k])">
		                               {{i.exenname[k]!=''&&i.exenname[k]!=null?i.exenname[k]:s}}
		                           </span> -->
														<div class="talker-name-p" v-for="(s, k) in i.exname" :key="k"
															@click="todetails(i.exid[k])">
															<p v-html="i.exenname[k]!=''&&i.exenname[k]!=null?nToBr(i.exenname[k]):nToBr(s)"></p>
															<p v-if="i.excompany[k]!=null&&i.excompany[k]!=''" 
																v-html="i.exencompany[k]!=''&&i.exencompany[k]!=null?nToBr(i.exencompany[k]):nToBr(i.excompany[k])">
															</p>
														</div>
														</p>
													</div>
												</li>
											</ul>
											<ul v-else>
												<li>
													<div class="talker-name">
														<span v-html="items.entopic!=null&&items.entopic!=''?nToBr(items.entopic):nToBr(items.topic)"></span>
													</div>
												</li>
											</ul>
										</div>
		 						</div>
								</li>
							</ul>
						</li>
					</ul>
				</ul>
			</template>
			<div class="modal" v-if="modalShow">
				<div class="details-conss">
					<DetailsNews :exid="exid" :introStatus="introShow" @func="closeGuest" />
				</div>
			</div>
			<van-popup v-model="showPopuop" :style="{ padding: '10%', fontSize: '14px' }">无相关会议</van-popup>
		</div>
	</div>
</template>
<script>
	import DetailsNews from './details-news.vue';
	export default {
		name: 'list',
		props: ['introShow'],
		components: {
			DetailsNews
		},
		data() {
			return {
				loading: false,
				loading1: false,
				datas: {},
				finished: false, //加载动画
				dataList: [],
				m: this.m,
				roomid: '',
				top: 0,
				modalShow: false,
				showPopuop: false,
				language: 0, //0中文，1英文
			}
		},
		watch: {
			$route(to, from) {
				if (to.query.roomid != from.query.roomid && to.query.roomid) {
					this.roomid = to.query.roomid
					this.init()
				}
			},
		},
		created() {
			this.language = this.$route.query.language
			if (this.$route.query) {
				this.roomid = this.$route.query.roomid
				this.top = this.$route.query.top
				this.init()
			}
		},
		methods: {
			goBack() {
				this.$router.go(-1);
			},
			convertTime(time) {
				let end = time.split('(')[1].split(')')[0]
				// 将时间戳转时间格式
				let date = new Date(Number(end))
				let h = date.getHours()
				h = h < 10 ? '0' + h : h
				let m = date.getMinutes()
				m = m < 10 ? '0' + m : m
				return h + ':' + m
			},

			dealData(firstId, data) {
				let _temp = []
				for (let i = 0; i < data.length; i++) {
					if (data[i].upproid === firstId) {
						this.num++
						_temp.push(data.splice(i, 1)[0])
						i--
					}
				}
				for (let i = 0; i < _temp.length; i++) {
					_temp[i].children = this.dealData(_temp[i].proid, data)
				}
				return _temp
			},

			async init() {
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				});
				let {
					roomid,
					m
				} = this.$route.query
				this.m = m
				if (roomid === undefined) {
					this.$router.push({
						path: 'place',
						query: {
							m
						},
					})
				}
				this.loading = true
				try {
					const {
						m,
						dateid = 0,
						roomid = 0,
						search = ''
					} = this.$route.query //获得路由的参数
					const _params = Object.assign({
							m,
							dateid,
							roomid,
						},
						search ? {
							search
						} : {}
					) //search 是空字符串 为false 有值是true
					const res = await this.$http.initScheduleInfo(_params)
					this.$emit('searchDatas', res.childens)
					console.log(res.childens)
					if (res.RoomDateEntity != null) {
						this.datas = res.RoomDateEntity
						if(this.datas.prodate.indexOf('月')!=-1){
							this.datas.prodate = this.datas.prodate.replace('月','.')
						}
						if(this.datas.prodate.indexOf('日')!=-1){
							this.datas.prodate = this.datas.prodate.replace('日',' ')
						}
						console.log(this.datas)
						res.childens[0].roomurl = res.RoomDateEntity.roomurl

						let _list
						console.log(res.DateListEntity.length)
						if (res.DateListEntity != null && res.DateListEntity.length > 0) {
							_list =
								res.DateListEntity[0].programListEntity[0].programs.programList
							this.num = 0
							const _data = this.dealData(0, _list)
							// console.log(_data, '处理后的日程数据')

							this.dataList = this.getSubAgendaData(_data)

							for (let i = 0; i < _data.length; i++) {
								this.dataList[i].children = this.getSubAgendaData(_data[i].children)
							}
						}
						console.log(this.dataList)
						this.loading = false
						
						let that = this
						if( that.top ){
							this.$nextTick(() => {
								setTimeout(function() {
									document.querySelector('#top'+that.top+'').scrollIntoView({
										behavior: "smooth",  // 平滑过渡
										block:    "start"  // 上边框与视窗顶部平齐。默认值
									})
									
								}, 1000)
							})
						}
						
						
					} else {
						this.showPopuop = true
						this.loading = false
					}
				} catch (error) {
					console.error(error)
				}

				this.finished = true
			},

			getSubAgendaData(data) {
				console.log('处理数据',data)
				let SubAgendaData = []
				for (let k = 0; k < data.length; k++) {
					let endtime = data[k].endtime,
						startime = data[k].starttime,
						children = data[k].children,
						proid = data[k].proid,
						exData = [],
						exenname = [],
						exid = [],
						roleenname = ''
					let exnameId = []
					for (let s = 0; s < data[k].expertList.length; s++) {
						exid.push(data[k].expertList[s].exid)
						exenname.push(data[k].expertList[s].exenname)
						roleenname = data[k].expertList[s].exrolemodel.roleenname
						exnameId.push({
							exname: data[k].expertList[s].exname,
							exid: data[k].expertList[s].exid,
							excompany: data[k].expertList[s].excompany,
							exenname: data[k].expertList[s].exenname,
							exencompany: data[k].expertList[s].exencompany,
						})

						exData = this.filterRolename(data[k].expertList)
					}

					SubAgendaData.push({
						children,
						startime,
						endtime,
						topic: data[k].topic,
						proid,
						exid,
						exData,
						//英文数据 ----
						entopic: data[k].entopic,
						exenname,
						roleenname,
					})
				}
				return SubAgendaData
				
			},
			filterRolename(data) {
				let _rolenameList = [], //已去重rolename
					_rolename = [] // 所有rolename

				//去掉重复的身份（rolename）
				for (let i in data) {
					_rolename.push(data[i].exrolemodel.rolename)
					let _indexof = _rolenameList.indexOf(_rolename[i])
					if (_indexof == -1) {
						_rolenameList.push(data[i].exrolemodel.rolename)
					}
				}
				let _identityList = [] //去重后的身份和姓名总数据
				_rolenameList.forEach((item) => {
					let _identity = {
						rolename: '',
						exname: [],
						exid: [],
						excompany: [],
						exenname: [],
						exencompany: []
					}
					let _exname = [], //同一身份的嘉宾姓名
						_exid = [],
						_excompany = [],
						_exenname = [],
						_exencompany = [];
					for (let n in data) {
						if (item === data[n].exrolemodel.rolename) {
							_exname.push(data[n].exname)
							_identity.rolename = item
							_identity.exname = _exname
							_exid.push(data[n].exid)
							_identity.exid = _exid
							_excompany.push(data[n].excompany)
							_identity.excompany = _excompany
							_exenname.push(data[n].exenname)
							_identity.exenname = _exenname
							_exencompany.push(data[n].exencompany)
							_identity.exencompany = _exencompany
						}
					}
					_identityList.push(_identity)
				})

				return _identityList
			},
			/**
			 * @description 进入到子路由 封装的方法
			 * @param {Objcet} param 路由需要的参数
			 */
			todetails(param) {
				this.modalShow = true
				this.exid = param
			},
			goMeeting(e, dateid, roomid) {
				const params = {
					m: this.$route.query.m,
					roomid: roomid,
					dateid: dateid
				}
				this.$router.push({
					path: 'scheduleList',
					query: params,
				})
			},
			getIntro() {
				this.tabShow1 = true
				this.tabShow2 = false
			},
			getdetails() {
				this.tabShow1 = false
				this.tabShow2 = true
			},
			closeGuest() {
				this.modalShow = false
			},
			nToBr (str){
				if( str ){
					return str.replace(/\\n/g,'<br/>');
				}else{
					return str
				}
			
			},
		},
	}
</script>
<style lang="scss" scoped>
	// .list {
	//   width: 100%;
	//   background: #efeff4;
	//   .list-con {
	//     .list-con-main {
	//       margin: 10px;
	//       font-size: 26px;
	//     }
	//     .list-head {
	//       box-shadow: 0 2px 12px rgba(0,0,0,0.04);
	//       .list-head-title {
	//         box-shadow: 0 2px 12px rgba(0,0,0,0.04);
	//         margin: 1px 0px 6px 0px;
	//         ul {
	//           padding: 10px 0;
	//           background: #fff;
	//           li {
	//             .van-cell {
	//               font-size: 28px;
	//               padding: 12px 16px;
	//               font-weight: 440;
	//               color: #000;
	//               line-height: 36px;
	//               i {
	//                 width: 40px;
	//                 font-size: 34px;
	//                 color: #000;
	//                 line-height: 36px;
	//               }
	//             }
	//             .list-head-title-address {
	//               i {
	//                 color: #3b82f6;
	//                 font-weight: bold;
	//               }
	//             }
	//           }
	//         }
	//       }
	//     }
	//     h4 {
	//       height: 80px;
	//       line-height: 80px;
	//       margin-left: 10px;
	//       font-size: 28px;
	//     }
	//     .schedule-list {
	//       margin-bottom: 100px;
	//       .schedule-list-box {
	//         margin-bottom: 20px;
	//         background: #fff;
	//         box-shadow: 0 2px 12px rgba(0,0,0,0.04);
	//         .schedule-list-head {
	//           padding: 20px 0;
	//           margin-bottom: 20px;
	//           font-size: 28px;
	//           display: flex;
	//           border-bottom: 1px solid #e2e8f0;

	//           .schedule-list-time {
	//             width: 180px;
	//             padding-left: 16px;
	//             color: #3b82f6;
	//           }
	//           .schedule-list-title {
	//             flex: 1;
	//             .schedule-list-sub {
	//               & > li {
	//                 padding: 8px 0;
	//                 line-height: 36px;
	//                 padding-right: 6%;
	//               }
	//               .major-title {
	//                 display: flex;
	//                 .major-title-topic {
	//                   flex: 1;
	//                   font-size: 28px;
	//                 }
	//                 > .van-cell {
	//                   width: 42px;
	//                   display: inline-block;
	//                   padding: 0px;
	//                 }
	//                 i {
	//                   font-size: 34px;
	//                   color: #000;
	//                   line-height: 36px;
	//                 }
	//                 .van-cell:not(:last-child)::after {
	//                   border: none;
	//                 }
	//               }
	//               .talker {
	//                 font-weight: bolder;
	//               }
	//             }
	//           }
	//         }
	//         .schedule-list-child {
	//           display: flex;
	//           font-size: 28px;
	//           .schedule-list-child-time {
	//             width: 190px;
	//             padding-left: 16px;
	//             font-size: 28px;
	//           }
	//           .schedule-list-child-main {
	//             flex: 1;
	//             border-left: 2px solid #e2e8f0;
	//             position: relative;
	//             padding-left: 20px;
	//             border-top-left-radius: 10px;
	//             margin-left: 22px;
	//             padding-bottom: 20px;
	//             .schedule-list-child-icon {
	//               width: 32px;
	//               height: 32px;
	//               position: absolute;
	//               top: 6px;
	//               left: -18px;
	//               background: #fff;
	//               border: 1px solid #3b82f6;
	//               border-radius: 32px;
	//               text-align: center;
	//               > .van-icon {
	//                 font-size: 28px;
	//                 color: #3b82f6;
	//               }
	//             }
	//             ul {
	//               margin: 0 16px 0 10px;

	//               .child-main-head,
	//               .child-main-speaker {
	//                 margin-bottom: 20px;
	//                 font-size: 28px;
	//               }
	//               .child-main-speaker {
	//                 color: #3b82f6;
	//                 > div {
	//                   color: #3b82f6;
	//                   font-weight: 400;
	//                 }
	//                 > div:first-child {
	//                   font-weight: bolder;
	//                   color: #000;
	//                   margin-right: 20px;
	//                 }
	//               }
	//             }
	//           }
	//         }
	//       }
	//     }
	//   }
	//   ._link {
	//     span {
	//       color: #3b82f6;
	//     }
	//   }
	//   .talker-name {
	//     color: #3b82f6;
	//     display: flex;
	//     flex-wrap: wrap;
	//     flex-direction: row;
	//     > span {
	//       margin-right: 20px;
	//     }
	//   }
	// }
	.list {
		margin-bottom: 80px;
		font-size: 26px;
		line-height: 1.5;
		padding: 0 20px 20px;

		.details-return {
			position: fixed;
			right: 0;
			bottom: 80px;
			width: 84px;
			height: 60px;
			z-index: 100;
			background: #3b82f6;
			border-radius: 30px 0 0 30px;
			text-align: center;
			line-height: 60px;
			color: #fff;

			img {
				height: 100%;
			}
		}

		.meetinglist {
			background: #fff;
			margin-top: 20px;
			padding: 20px;
			position: relative;
			-webkit-box-shadow: 0 2px 12px rgba(0,0,0,0.04);
			box-shadow: 0 2px 12px rgba(0,0,0,0.04);
			border-radius: 12px;

			li {
				.meeting-top {
					width: 100%;
				}

				.meeting-date {
					width: 160px;
					padding: 10px 0 0 0;
					font-weight: bold;
					display: flex;
					align-items: flex-start;
					flex-direction: column;
					justify-content: flex-end;

					p {
						font-size: 42px;
						color: #1e293b;
					}

					p:last-child {
						font-size: 64px;
						color: #64748b;
						margin-top: 5px;
					}
				}

				.meeting-info {
					flex: 1;
					padding-bottom: 10px;

					.meeting-title {
						margin: 20px 0;
						font-size: 30px;
					}

					.meeting-time {
						margin-top: 3px;
						font-size: 29px;
					}

					.van-cell {
						padding: 0;
						font-size: 29px;
						line-height: 1.5;
						color: #64748b;

						.van-cell__left-icon {
							line-height: 40px;
							font-size: 28px;
						}

						.van-cell__value--alone {
							color: #64748b;
						}
					}
				}

				.meeting-icon {
					position: absolute;
					right: 0;
					top: 30px;
					width: 160px;
					display: flex;
					align-items: flex-end;
					justify-content: center;
					background: #3b82f6;
					padding: 10px 0;
					border-radius: 50px 0 0 50px;

					a {
						color: #fff;
						display: block;
						text-align: center;
					}

					img {
						width: 30px;
						vertical-align: -4px;
					}

					p {
						font-size: 12px;
					}
				}

				.meeting-arrow {
					width: 100%;
					text-align: center;

					.van-icon {
						font-size: 40px;
						transform: rotate(90deg);
						color: #64748b;
					}
				}

				.arrows {
					.van-icon {
						font-size: 40px;
						transform: rotate(-90deg);
						color: #64748b;
					}
				}
			}
		}

		.meetinglists {
			.meeting-infos {
				display: flex;
				background: #f8fafc;
				margin: 20px 0;
				padding: 10px 5px;

				.meeting-times {
					width: 180px;
					margin: 5px 0;
				}

				.meeting-nextDatas {
					flex: 1;

					li {
						margin: 5px 0;
					}

					.talker-name {
						color: #1e293b;

						p {}

						.talker-name-p {
							color: #3b82f6;
							margin-bottom: 5px;
						}

						span {
							margin: 0 10px;
							color: #3b82f6;

							i {
								color: #3b82f6;
							}
						}
					}
				}
			}

			.meeting-infos-zhu {
				background: #eff6ff;
			}
		}
	}

	.modal {
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background: rgba(0, 0, 0, .5);
		z-index: 1000;

		.details-conss {
			background: #fff;
			// padding: 20px 0;
			// -webkit-box-shadow: 0 2px 12px rgba(0,0,0,0.04);
			// box-shadow: 0 2px 12px rgba(0,0,0,0.04);
			margin-bottom: 20px;
			//border-radius: 12px;
			position: absolute;
			left: 50%;
			top: 50%;
			z-index: 10001;
			transform: translate(-50%, -50%);
			width: 90%;
			height: 80%;
			overflow-y: auto;
		}
	}
</style>
